<template>
  <div>
    <!-- Modal -->
    <modal
      v-if="mostrarModal"
      :show.sync="mostrarModal"
      :show-close="false"
      @close="fecharModal"
      body-classes="p-2 text-dark"
      modal-classes="modal-dialog-centered super-modal"
      close-classes="text-white"
    >
      <div>
        <slot name="header">
          <h3 class="my-2 text-center">Bem-vindo!</h3>
        </slot>
        <div class="p-2 mb-2 text-center">
          <p class="p-modal">
            Descubra uma nova forma de comprar online!
            <br />
            Abra um box surpresa e receba produtos incríveis em casa ou viva
            experiências únicas que ficarão na memória.
          </p>
          <p class="text-white">Assista ao vídeo abaixo e saiba mais!</p>

          <iframe
            width="100%"
            height="300"
            src="https://www.youtube.com/embed/7BLipDwSIdo"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="text-center mt-3">
          <button @click="fecharModal" class="btn btn-secondary">Fechar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      mostrarModal: false,
    };
  },
  methods: {
    verificarLocalStorage() {
      const modalAberta = localStorage.getItem('modalAberta');
      if (!modalAberta || modalAberta === 'false') {
        this.mostrarModal = true;
        localStorage.setItem('modalAberta', 'true');
      }
    },
    fecharModal() {
      this.mostrarModal = false;
    },
  },
  mounted() {
    this.verificarLocalStorage();
  },
};
</script>
<style>
.super-modal {
  z-index: 1050 !important;
}
</style>

<style scoped lang="scss">
.p-modal {
  color: #f4a424;
  font-weight: 500;
}

h3 {
  font-size: 27px;
  font-weight: 700;
}

.modal-dialog-centered {
  max-width: 500px;
}

.modal-body {
  background-color: #f8f9fa;
  border-radius: 8px;
}
</style>
